module.exports = __webpack_public_path__ + "img/case-ct_pacecapsule.8ebaf43.png";